import { AppRoutes } from './AppRoutes';

/**
 * Routes the assistant knows by name.
 *
 * Every entry gives the screen an id, which the panel turns into a label through the
 * `aiChat.screens` keys. A route that is missing here still works: the assistant falls back to
 * the path. The most specific match wins, so listing a parent route covers its children.
 *
 * A new entry needs `aiChat.screens.<id>` in `src/i18n/en/aiChat.ts`. If the assistant must
 * describe the screen, it also needs a screen document on the backend.
 * @see [12.5 Register a screen on the frontend](../../docs/mockups/ai-agents/ai-chat/ATT-144_AI_Chat_Assistant.md)
 * @see [12.7 Add or change a screen document](../../docs/mockups/ai-agents/ai-chat/ATT-144_AI_Chat_Assistant.md)
 */
export const AI_SCREEN_CONTEXT_ROUTES: { path: string, screen: string }[] = [
  { path: AppRoutes.launchpad, screen: 'launchpad' },
  { path: AppRoutes.launchpadHub, screen: 'launchpadHub' },
  { path: AppRoutes.launchpadSettings, screen: 'settings' },
  { path: AppRoutes.releaseHistory, screen: 'releaseHistory' },
  { path: AppRoutes.userManagement, screen: 'userManagement' },
  { path: AppRoutes.companyUiConfiguration, screen: 'uiConfiguration' },
  { path: AppRoutes.balanceSheetAssets, screen: 'balanceSheetAssets' },
  { path: AppRoutes.suppliers, screen: 'suppliers' },
  { path: AppRoutes.customers, screen: 'customers' },
  { path: AppRoutes.products, screen: 'products' },
  { path: AppRoutes.profitCentres, screen: 'profitCentres' },
  { path: AppRoutes.valueChainMap, screen: 'valueChainMap' },
  { path: AppRoutes.companyMap, screen: 'companyMap' },
  { path: AppRoutes.taskManagement, screen: 'taskManagement' },
  { path: AppRoutes.taskManagementId, screen: 'taskInfo' },
  { path: AppRoutes.materialityAssessment, screen: 'materialityAssessment' },
  { path: AppRoutes.standards, screen: 'standards' },
  { path: AppRoutes.standardsIRO, screen: 'standardsIRO' },
  { path: AppRoutes.sectorSpecific, screen: 'sectorSpecific' },
  { path: AppRoutes.agentsManagement, screen: 'agentsManagement' },
  { path: AppRoutes.watchTowerCompany, screen: 'watchTowerCompany' },
  { path: AppRoutes.watchTower, screen: 'watchTower' },
  { path: AppRoutes.marketingOpsFinding, screen: 'marketingOpsFinding' },
  { path: AppRoutes.marketingOps, screen: 'marketingOps' },
  { path: AppRoutes.settingWeighting, screen: 'settingWeighting' },
  { path: AppRoutes.clients, screen: 'clients' },
  { path: AppRoutes.clientProfile, screen: 'clientProfile' },
  { path: AppRoutes.profile, screen: 'profile' },
];

export default AI_SCREEN_CONTEXT_ROUTES;
